/*
 *
 * SettingsBankStatementPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 29-Apr-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { useIntl } from 'react-intl'
import MerchantFlowCard from '@nexidigital/merchantflowcard'
import './SettingsBankStatementPopup.scss'

const SettingsBankStatementPopup = (props) => {
  const intl = useIntl()
  return (
    <Toggle>
      <MerchantModal
        onClose={() => props.actions.doHidePopup()}
        primaryAction={() => props.actions.doShowPopup()}
        primaryButtonLabel={intl.formatMessage({ id: 't.app.confirm' })}
        title={intl.formatMessage({ id: 't.app.settings.bankstatement.modalTitle.popup' })}
      >
        <MerchantFlowCard
          title={intl.formatMessage({ id: 't.app.settings.bankstatement.title.popup' })}
          subtitle={intl.formatMessage({ id: 't.app.settings.bankstatement.subtitle.popup' })}
        />
      </MerchantModal>
    </Toggle>
  )
}

SettingsBankStatementPopup.propTypes = {
  actions: PropTypes.object.isRequired
}

SettingsBankStatementPopup.defaultProps = {
  actions: {}
}

export default SettingsBankStatementPopup
